import { bool, func } from "prop-types";

import styled from "styled-components";

import { useNewGivingUI, usePermissions } from "Flocknote/apiHooks";
import { useIsSuperDuper } from "Flocknote/stateHooks";

import { menuTypographyProps } from "NavBar/components/NavLink";
import SettingsOptionWrapper from "NavBar/components/settings/SettingsOptionWrapper";
import SettingsOptionsWrapper from "NavBar/components/settings/SettingsOptionsWrapper";
import { navSectionKeys, useActiveSectionKey } from "NavBar/navBarStore";
import { useCloseNavIfOpen } from "NavBar/stateHooks";
import { menuIconProps } from "NavBar/styleConstants";

import FnrShineButton from "UI/FnrButton3/FnrShineButton";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrToggleSwitch from "UI/FnrToggleSwitch";
import FnrTypography from "UI/FnrTypography";

const getDestination = (showNewGivingUI, canOnlyAddGifts) => {
  if (!canOnlyAddGifts) return "/giving";
  return showNewGivingUI ? "/giving/input" : "/giving/batches/new-batch";
};

const SettingsContent = ({ setCloseTrigger, hideAdminOptions }) => {
  const [{ canSeeMMGSetup }] = usePermissions();
  const isSuperDuper = useIsSuperDuper();
  const closeNavIfOpen = useCloseNavIfOpen();
  const [, setActiveSectionKey] = useActiveSectionKey();
  const {
    showNewGivingUI,
    setShowNewGivingUI,
    canViewLegacyGivingUI,
    hideLegacyGivingUI,
  } = useNewGivingUI();

  const [{ canViewAllGivingData, canSeeCampaignsNav, canAddGifts }] =
    usePermissions();

  const canOnlyAddGifts =
    canAddGifts && !canViewAllGivingData && !canSeeCampaignsNav;

  const handleGivingViewToggle = () => {
    setShowNewGivingUI(!showNewGivingUI);
    setCloseTrigger({});
    closeNavIfOpen();

    const destination = getDestination(showNewGivingUI, canOnlyAddGifts);
    window.fnReactBus.goToUrl(destination);

    window.location.reload();
  };

  return (
    <SettingsOptionsWrapper>
      {canViewLegacyGivingUI && (
        <FnrShineButton
          data-cy="NavBar_GivingViewToggle"
          onClick={handleGivingViewToggle}
          borderRadius={8}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="money-bill fad" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>
              {showNewGivingUI
                ? "Switch to Classic Giving"
                : "Switch to New Giving"}
            </FnrTypography>
          </SettingsOptionWrapper>
        </FnrShineButton>
      )}
      {!hideAdminOptions && isSuperDuper && (
        <FnrShineButton
          borderRadius={8}
          data-cy="NavBar_GivingHappeTools"
          onClick={() => {
            window.fnReactBus.goToUrl("/giving/settings/happetools");
            setCloseTrigger({});
            closeNavIfOpen();
          }}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="user-secret fad" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>Happe Tools</FnrTypography>
          </SettingsOptionWrapper>
        </FnrShineButton>
      )}
    </SettingsOptionsWrapper>
  );
};

SettingsContent.propTypes = { setCloseTrigger: func, hideAdminOptions: bool };

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
`;

export default SettingsContent;
